import { cn } from '@/lib/utils';

export const TEMPLATE_CATEGORY_COLOR: Record<string, { bg: string; fg: string }> = {
  MARKETING: { bg: 'rgba(255,105,0,0.1)', fg: '#ff6900' },
  UTILITY: { bg: 'rgba(21,93,252,0.08)', fg: '#155dfc' },
  AUTHENTICATION: { bg: 'rgba(0,166,62,0.1)', fg: '#00a63e' },
};

export function templateCategoryLabel(category?: string | null): string {
  const cat = (category || '').toString().toUpperCase();
  if (!cat) return '—';
  return cat.charAt(0) + cat.slice(1).toLowerCase();
}

export function TemplateCategoryPill({
  category,
  className,
}: {
  category?: string | null;
  className?: string;
}) {
  const cat = (category || '').toString().toUpperCase();
  if (!cat) return <span className="text-[#667085]">—</span>;

  const tone = TEMPLATE_CATEGORY_COLOR[cat] || TEMPLATE_CATEGORY_COLOR.MARKETING;

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-md px-2 py-[3px] text-[11.5px] font-semibold',
        className,
      )}
      style={{ background: tone.bg, color: tone.fg }}
    >
      {templateCategoryLabel(cat)}
    </span>
  );
}
